<template>
  <div class="flex min-h-screen items-center justify-center bg-slate-100 p-5">
    <div
      class="grid w-full max-w-[980px] overflow-hidden rounded-2xl bg-white shadow-[0_24px_70px_rgba(15,23,42,0.22)] md:grid-cols-[0.95fr_1.05fr]"
    >
      <!-- Panel trái: thương hiệu -->
      <div
        class="flex min-h-[520px] items-center justify-center bg-[linear-gradient(135deg,#0f766e_0%,#155e75_100%)] p-8 text-white"
      >
        <div class="flex max-w-[320px] flex-col items-center text-center">
          <img
            src="../assets/background.png"
            alt="Logo"
            class="h-28 w-28 rounded-2xl bg-white object-contain p-2 shadow-xl"
          />
          <h2 class="mt-5 text-3xl font-black">Xã Trà Đốc</h2>
          <p class="mt-2 text-sm font-semibold text-white/80">
            Thành phố Đà Nẵng
          </p>
          <div class="my-6 h-px w-24 bg-white/30"></div>
          <div
            class="flex items-center gap-3 rounded-full bg-white/10 px-4 py-3 text-sm font-bold"
          >
            <img
              src="../assets/Zalo.png"
              alt="Zalo"
              class="h-8 w-8 rounded-lg bg-white object-contain"
            />
            <span>Hệ thống nhắn tin Zalo OA</span>
          </div>
        </div>
      </div>

      <!-- Panel phải: form -->
      <div class="flex items-center justify-center p-8">
        <div class="w-full max-w-[360px]">
          <div class="mb-7 text-center">
            <div
              class="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-full bg-teal-50"
            >
              <i class="pi pi-lock text-xl text-teal-700 leading-none"></i>
            </div>
            <h3>Đăng nhập hệ thống</h3>
            <p>Vui lòng nhập thông tin tài khoản của bạn</p>
          </div>

          <div class="mb-4">
            <label for="username">
              <span class="pi pi-user mr-2 text-teal-700"></span> Tên đăng nhập
            </label>
            <InputText
              id="username"
              type="text"
              v-model="userName"
              placeholder="Nhập tên đăng nhập"
              class="w-full"
              autocomplete="username"
            />
          </div>

          <div class="mb-4">
            <label for="password">
              <span class="pi pi-key mr-2 text-teal-700"></span> Mật khẩu
            </label>
            <Password
              id="password"
              v-model="password"
              placeholder="Nhập mật khẩu"
              class="w-full"
              :toggleMask="true"
              @keyup.enter="doLogin()"
            />
          </div>

          <Button
            label="Đăng nhập"
            icon="pi pi-sign-in"
            iconPos="left"
            class="mt-2 w-full"
            :disabled="!valid || loading"
            :loading="loading"
            @click="doLogin()"
          />

          <p class="!mt-6 text-center text-xs font-semibold text-slate-500">
            © 2026 Xã Trà Đốc · Designed by Mobifone
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Login } from "../models/login";
import { computed } from "vue";
import { ref } from "vue";
import AuthRepository from "../services/AuthRepository";
import { useStore } from "vuex";
import { useToast } from "@/ui/services/toast";
import { useRouter } from "vue-router";

export default {
  setup(props) {
    const router = useRouter();
    const login = ref({} as Login);
    const store = useStore();
    const toast = useToast();
    const userName = ref("");
    const password = ref("");
    const loading = ref(false);

    const valid = computed(() => password.value && userName.value);

    // if(!(store.state.permission == "admin")){
    //   router.push({
    //     name: 'home'
    //   });
    // }

    console.log("############################## loginpage 11111");
    const doLogin = () => {
      if (loading.value) return;
      loading.value = true;
      console.log("############################## loginpage");
      var md5 = require("md5");
      login.value.username = userName.value;
      login.value.password = password.value;
      console.log(
        "############################## loginpage login: " +
          JSON.stringify(login),
      );
      AuthRepository.auth(login.value)
        .then((response) => {
          store.dispatch("setToken", response.data.token);
          console.log("############################## loginpage success");
          toast.add({
            severity: "success",
            summary: "Đăng nhập",
            detail: "Đăng nhập thành công vào hệ thống",
            life: 1000,
          });
          AuthRepository.userPermission(login.value)
            .then((response) => {
              store.dispatch("setPermission", response.data.permission);
              console.log(
                "############################## loginpage permission",
              );
            })
            .catch(() => {
              store.dispatch("clearPermission");
              console.log(
                "############################## loginpage permission failed",
              );
              return;
              toast.add({
                severity: "error",
                summary: "Đăng nhập",
                detail:
                  "Đăng nhập thất bại. Vui lòng kiểm tra lại thông tin đăng nhập",
                life: 1000,
              });
            });
          router.push({
            name: "sendmessage",
          });
          loading.value = false;
        })
        .catch(() => {
          toast.add({
            severity: "error",
            summary: "Đăng nhập",
            detail:
              "Đăng nhập thất bại. Vui lòng kiểm tra lại thông tin đăng nhập",
            life: 1000,
          });
          loading.value = false;
        });
    };

    return {
      login,
      doLogin,
      valid,
      password,
      userName,
      loading,
    };
  },
};
</script>
`r`n
